import { createToast } from "#src/common/system/toasts";
import { ButtonV2 } from "#src/commonV2/Button";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";
import { IThreatPreventionPolicyItem } from "#src/services/endpoint/devices/types";
import { endpointService } from "#src/services/endpoint";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import { useTranslation } from "react-i18next";
import { ModalHeaderIcon } from "#src/commonV2/modal/ModalHeaderIcon";
import { AlertCircle } from "@untitled-ui/icons-react";

interface IConfirmDeleteThreatPreventionPolicyModalProps {
  open: boolean;
  onChangeOpen: (value: boolean) => void;
  workspaceId: string;
  data: IThreatPreventionPolicyItem | null;
  updateThreatPolicyList: () => void;
}

export const ConfirmDeleteThreatPreventionPolicyModal = ({
  open,
  onChangeOpen,
  workspaceId,
  data,
  updateThreatPolicyList,
}: IConfirmDeleteThreatPreventionPolicyModalProps) => {
  const { t } = useTranslation("endpoint", {
    keyPrefix: "threatPrevention.modal.delete",
  });

  // --------------- METHODS ---------------

  const deleteControl = () => {
    if (data) {
      endpointService
        .deleteThreatPolicy(workspaceId, data.id)
        .then(() => {
          updateThreatPolicyList();
          createToast({
            type: "success",
            message: "Threat prevention policy has been deleted",
          });
        })
        .catch(apiErrorHandler);
    }
  };

  // --------------- RENDER ---------------

  return (
    <ModalV2 open={open} onChangeOpen={onChangeOpen} className="gap-8">
      <div className="flex gap-4">
        <ModalHeaderIcon type="error" Icon={AlertCircle} />
        <div className="flex flex-col gap-5">
          <span className="text-lg font-semibold text-gray-v2-900">
            {t("title")}
          </span>
          <span className="text-md text-gray-v2-600 whitespace-pre-line">
            {t("confirmQuestion")}
          </span>
        </div>
      </div>
      <div className="flex justify-end gap-1">
        <ButtonV2
          variant="secondary"
          color="gray"
          size="lg"
          onClick={() => {
            onChangeOpen(false);
          }}
        >
          {t("button.cancel")}
        </ButtonV2>
        <ButtonV2
          variant="primary"
          size="lg"
          color="error"
          onClick={() => {
            onChangeOpen(false);
            deleteControl();
          }}
        >
          {t("button.delete")}
        </ButtonV2>
      </div>
    </ModalV2>
  );
};
